import React from 'react';

import ChangelogDialog from '@/components/ChangelogDialog';
import { version } from '@/constants/env';

const STORAGE_KEY = 'wagako_last_seen_version';

const ChangelogOnUpdate: React.FC = () => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const run = async () => {
      try {
        // Service Worker の登録は window 'load' 後に走るため、
        // それまでは SW の状態が取得できず、誤判定で表示される恐れがある。
        if (document.readyState !== 'complete') {
          await new Promise<void>((resolve) => { window.addEventListener('load', () => resolve(), { once: true }); });
        }

        // 1) SW 更新待ち中は表示スキップ（onUpdate がまだ走る前の競合も避ける）
        if (sessionStorage.getItem('swUpdatePending') === '1') return;
        if ('serviceWorker' in navigator) {
          const reg = await navigator.serviceWorker.getRegistration();
          if (reg && (reg.waiting || reg.installing)) return;
        }

        // 2) リロード後にのみ表示するためのフラグがある場合は優先して表示
        const afterReload = sessionStorage.getItem('showChangelogAfterReload') === '1';
        if (afterReload) {
          setOpen(true);
          sessionStorage.removeItem('showChangelogAfterReload');
          localStorage.setItem(STORAGE_KEY, version);
          return;
        }

        // 3) 通常のバージョン差分での表示（初回訪問や手動リロード時）
        const prev = localStorage.getItem(STORAGE_KEY);
        if (prev && prev !== version) {
          setOpen(true);
        }
        localStorage.setItem(STORAGE_KEY, version);
      } catch {
        // Storage 未対応環境では何もしない
      }
    };
    run();
  }, []);

  return (
    <ChangelogDialog
      open={open}
      version={version}
      onClose={() => setOpen(false)}
    />
  );
};

export default ChangelogOnUpdate;
